var _g, _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockAndunblock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C2.91014 0 0 2.91014 0 6.5C0 10.0899 2.91014 13 6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91014 10.0899 0 6.5 0ZM3.94414 2.62551C4.70252 2.12477 5.59122 1.85761 6.5 1.85714C7.41009 1.85619 8.30012 2.12434 9.05821 2.62786L2.62786 9.05821C1.21501 6.91838 1.8043 4.03839 3.94414 2.62551ZM9.05586 10.3745C8.29748 10.8752 7.40881 11.1424 6.5 11.1429C5.58991 11.1438 4.69988 10.8757 3.94179 10.3721L10.3721 3.94179C11.785 6.08159 11.1957 8.96161 9.05586 10.3745Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 10,
    r: 3.5,
    fill: "#CC5A5A",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.56 9.04V9.4H11.06V9.04C11.06 8.46 10.6 8 10.04 8C9.46 8 9 8.46 9 9.04V9.8H9.5V9.04C9.5 8.75999 9.74 8.51999 10.02 8.51999C10.32 8.5 10.56 8.74 10.56 9.04Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7202 9.76001H10.4802C10.3202 9.76001 10.2002 9.88001 10.2002 10.04V11.72C10.2002 11.88 10.3202 12 10.4802 12H12.7202C12.8802 12 13.0002 11.88 13.0002 11.72V10.04C13.0002 9.90002 12.8602 9.76001 12.7202 9.76001ZM11.8402 11.38H11.3802L11.4802 10.9C11.4002 10.86 11.3402 10.76 11.3402 10.66C11.3402 10.5 11.4602 10.38 11.6202 10.38C11.7802 10.38 11.9002 10.5 11.9002 10.66C11.9002 10.76 11.8402 10.84 11.7602 10.9L11.8402 11.38Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockAndunblock);
export default __webpack_public_path__ + "static/media/block-and unblock.037bfa9026b466af0a6f5e32de6a6b80.svg";
export { ForwardRef as ReactComponent };